// extracted by mini-css-extract-plugin
export var dropdownButton = "_36-0";
export var fullWidthDropdownButton = "_36-1";
export var icon = "_36-3";
export var iconPlaceholder = "_36-2";
export var menuItemRow = "_36-9";
export var separator = "_36-e";
export var shortcutContainer = "_36-7";
export var shortcutContainerFilled = "_36-8";
export var shortcutIconLg = "_36-6";
export var shortcutIconMd = "_36-5";
export var shortcutIconSm = "_36-4";
export var submenuChevron = "_36-d";
export var submenuDropdown = "_36-a";
export var submenuTriggerRow = "_36-b";
export var submenuTriggerRowOpen = "_36-c";